module.exports = __webpack_public_path__ + "static/img/page2-bg.eb5c9cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/page2-bg.png
// module id = XCls
// module chunks = 215